
import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Edit from "../../../../icons/edit.svg";
import Trash from "../../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import SetupNotificationsEditandAdd from "./SetupNotificationsEditandAdd";
import axios from '../../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../../Nodata/Nodata";
import { HasScreenPermissions, HasPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../../utils/Enums.json";

export default function SetupNotifications() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [shows, setShow] = useState(true);


    const [open, setOpen] = useState(false);
    const [Id, setID] = useState("");
    const [SetupId, setSetupId] = useState("");
    const [Refresh, setRefresh] = useState(false);
    const [Data, setData] = useState({});

    const OpenTab = (num, r) => {
        if (num == 3)
            setSetupId(r?.orgEmailSetupId);
        if (num == 2)
            setData(r);
        setID(num);
        setOpen(true);
    };

    const CloseTab = () => {
        setOpen(false);
    };
    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };
    useEffect(() => {
        Details();
    }, [Refresh]);

    const [ClientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [NotificationsList, setNotificationsList] = React.useState([]);
    const [docTypeList, setDocTypeList] = React.useState([]);
    const [pqStatusList, setPqStatusList] = React.useState([]);

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
    }
    const ChangeClient = async (val) => {
        setClientId(val);
        setSpinner(!spinner);
        const res = await axios.get("EmailSetupNotifications/GetManageNotificationsList?clientId=" + val);
        setNotificationsList(res?.data?.data?.orgEmailSetupNotificationsList);
        setDocTypeList(res?.data?.data?.docTypeList);
        setPqStatusList(res?.data?.data?.prequalificationStatusList);
        setSpinner(false);
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog fullScreen={fullScreen} open={open} onClose={CloseTab}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{Id == 3 ? "Delete  Notification" : Id == 1 ? "Add Email Setup Notifications " : " Edit Email Setup Notifications "}</span>
                    </DialogTitle>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={spinner}
                        onClick={SpinnerClose}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <DialogActions >
                        <SetupNotificationsEditandAdd INFO={ChangeClient} ID={Id} CLOSE={CloseTab} SETUPID={SetupId} RESET={Refresh} RESETDATA={setRefresh} DATA={Data} DOCLIST={docTypeList} PQLIST={pqStatusList} CLIENTID={clientId} />
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Manage Notifications</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>

                    <Stack spacing={2} direction="row">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            value={clientId || ""}
                            id="demo-multiple-name"
                            size="small"
                            onChange={(e) => ChangeClient(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {ClientList?.map((r, i) =>
                                <MenuItem key={i} title={r?.text} value={r?.value} > {r?.text}</MenuItem>
                            )}
                        </Select>
                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                            {!HasScreenPermissions(INFO?.AddEmailSetupNotification?.actionName) &&
                                <Button variant="contained" sx={{ padding: "inherit" }} hidden={!clientId} onClick={() => OpenTab(1, "")} >+ Add New</Button>
                            }
                        </div>
                    </Stack >

                </div>
                {clientId == "" ? <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                    <span style={{ color: "#667085" }}>Please Select Client</span>
                </Box> :
                    NotificationsList?.length < 1 ?
                        <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                            <span style={{ color: "#667085" }}>No Notifications found</span>
                        </Box> : <>
                            <Box sx={{ backgroundColor: '#f8f9fa' }}>

                                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                    <Table aria-label="customized table">

                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Setup Type</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Name</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> First Notification</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Second Notification</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Third Notification</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Send Notifications To</span></StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>

                                            </TableRow>
                                        </TableHead>


                                        {NotificationsList?.map((r, i) => (
                                            <TableBody key={i}>

                                                <TableRow key={i} >

                                                    <StyledTableCell sx={{ width: "15%" }}>
                                                        {r?.setupType == 3 ? "Contractor Evaluation" : r?.setupType == 0 ? "Document Type" : "Prequalification Status"}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "20%" }}>
                                                        {r?.setupType == 3 ? " " : (r?.setupType == 0 ? docTypeList?.find((val) => val?.documentTypeId == r?.setupTypeId)?.documentTypeName :
                                                            pqStatusList?.find((val) => val?.prequalificationStatusId == r?.setupTypeId)?.prequalificationStatusName)}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "15%" }}>
                                                        {r?.firstNotification}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "15%" }}>
                                                        {r?.secondNotification}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "15%" }}>
                                                        {r?.thirdNotification}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "20%" }}>
                                                        {r?.sendNotificationTo}
                                                    </StyledTableCell>



                                                    <StyledTableCell sx={{ width: "5%" }} >
                                                        {!HasScreenPermissions(INFO?.AddEmailSetupNotification?.actionName) &&
                                                            <IconButton aria-label="edit" onClick={() => OpenTab(2, r)}>
                                                                <img src={Edit} alt="editicon" />
                                                            </IconButton>
                                                        }
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "5%" }}>
                                                        {HasPermissions(INFO?.ManageNotifications?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                            <IconButton aria-label="delete"  >
                                                                <img src={Trash} alt="trashicon" onClick={() => OpenTab(3, r)} />
                                                            </IconButton>
                                                        }
                                                    </StyledTableCell>

                                                </TableRow>

                                            </TableBody>
                                        ))}
                                    </Table>

                                </TableContainer>
                            </Box >
                        </>}

            </Card >

        </>
    )
}



